<template>
    <div class="m-chart">
        <section class="m-chart-tab" v-if="showTab">
            <ul class="m-chart-tab-trend">
                <li v-for="tab in tabs" :key="tab.name" @click="changeTab(tab, 1)">
                    <span :class="{'m-tab-choose': currentTrend === tab.type}">
                        {{tab.name}}
                        <em v-show="suitvalue === tab.type">适用</em>
                    </span>
                    <img v-show="currentTrend === tab.type" src="../../assets/images/tab.png" alt="#">
                    
                </li>
            </ul>
            <ul class="m-chart-tab-legend">
                <li v-for="legend in legends" :key="legend.color" class="u-block_il">
                    <span :style="{'background-color': legend.color}"></span>
                    <span f-font-PFR s-cr="#666666" class="g-fs24">{{legend.value}}</span>
                </li>
            </ul>
        </section>
        <ul class="m-chart-group" v-else>
            <li>
                <span><em></em>{{currentTrend === 'peguzhi' ? 'PE' : 'PB'}}</span>
                <span>{{hoverObj.pe | formatProfit}}</span>
            </li>
            <li>
                <span>{{currentTrend === 'peguzhi' ? 'PE百分位' : 'PB百分位'}}</span>
                <span>{{hoverObj.pePercent | formatProfit(true)}}</span>
            </li>
            <li>
                <span>30分位</span>
                <span>{{hoverObj.tpe | formatProfit}}</span>
            </li>
            <li>
                <span>70分位</span>
                <span>{{hoverObj.spe | formatProfit}}</span>
            </li>
        </ul>
        <div class="m-chart-line-wrapper" v-if="chooseData && chooseData.length > 0">
            <invest-line 
                :currentTrend="currentTrend" 
                :currentYear="currentYear" 
                :chooseData="chooseData"
                @changTabFlag="changTabFlag">
            </invest-line>
        </div>
        <div class="m-chart-line-wrapper1 g-pr" v-else>
            <span class="m-no-data g-fs24">暂无数据</span>
        </div>
        <ul class="m-chart-year u-pt20">
            <li 
                v-for="year in years" 
                :key="year.name" 
                @click="changeTab(year, 2)"
                :class="{'m-year-choose': currentYear === year.type}"
            >
                <span f-font-PFR s-cr="#323232" class="g-fs24 u-block_il">{{year.name}}</span>
            </li>
        </ul>
    </div>
</template>

<script>
    import InvestLine from './line1';
    export default {
        name: "chart",
        props: {
            historyList: {
                type: Object,
                default: () => {
                    return {
                        pbhistoryList: [],
                        pehistoryList: [],
                        time: '',
                        applyArea: ''
                    }
                }
            },
        },
        components: {
            InvestLine
        },
        computed: {
            suitvalue: function() {
                if (this.historyList.applyArea === 'PE') {
                    return 'peguzhi';
                } else if (this.historyList.applyArea === 'PB') {
                    return 'pbguzhi';
                } else {
                    return ''
                }
            }
        },
        data() {
            return {
                tabs: [{
                    name: 'PE估值走势',
                    type: 'peguzhi'
                }, {
                    name: 'PB估值走势',
                    type: 'pbguzhi'
                }],
                legends: [{
                    color: '#0080FF',
                    value: 'PE'
                }, {
                    color: '#00BB1D',
                    value: '低估区'
                }, {
                    color: '#FAA500',
                    value: '适中区'
                }, {
                    color: '#FF330A',
                    value: '高估区'
                }],
                years: [{
                    name: '近3年',
                    type: 'threeyear',
                }, {
                    name: '近5年',
                    type: 'fiveyear',
                }, {
                    name: '近10年',
                    type: 'tenyear',
                }, {
                    name: '成立来',
                    type: 'chengli',
                }],
                currentTrend: 'peguzhi',
                currentYear: 'threeyear',
                chooseData: [],
                showTab: true,
                hoverObj: {
                    pe: '--',
                    pePercent: '--',
                    tpe: '--',
                    spe: '--'
                }
            }
        },
        watch: {
            historyList: {
                handler(newList) {
                    console.log(1111,newList);
                    if (newList.applyArea === 'PE') {
                        this.currentTrend = 'peguzhi';
                    } else if (newList.applyArea === 'PB') {
                        this.currentTrend = 'pbguzhi';
                    }
                    this.changeTab('', -1 , false);
                },
                deep: true
            },
        },
        methods: {
            changeTab(obj, type, flag = true) {
                if (flag) {
                    _.log().clickStat(obj.type);
                }
                if (type === 1 || type === -1) {
                    if (type === 1) {
                        this.currentTrend = obj.type;
                    }
                    let color;
                    if (this.currentTrend === 'peguzhi') {
                        color = {
                            color: '#0080FF',
                            value: 'PE'
                        }
                    } else {
                        color = {
                            color: '#0080FF',
                            value: 'PB'
                        }
                    }
                    this.legends.splice(0, 1);
                    this.legends.unshift(color);
                } else if (type === 2) {
                    this.currentYear = obj.type;
                }
                let data = this.currentTrend === 'peguzhi' ? [...this.historyList.pehistoryList] : [...this.historyList.pbhistoryList];
                if (this.historyList.time) {
                    let arr = this.historyList.time.split('-');
                    let currentTime = this.historyList.time.replace(/-/g, '');
                    let lastTime = '';
                    switch(this.currentYear) {
                        case 'tenyear':
                            lastTime = `${arr[0] - 10}${arr[1]}${arr[2]}`;
                            break;
                        case 'threeyear':
                            lastTime = `${arr[0] - 3}${arr[1]}${arr[2]}`;
                            break;
                        case 'fiveyear':
                            lastTime = `${arr[0] - 5}${arr[1]}${arr[2]}`;
                            break;
                    }
                    this.chooseData = [];
                    if (this.currentYear !== 'chengli') {
                        data.forEach((item) => {
                            if (Number(item.date) > Number(lastTime) && Number(item.date) <= Number(currentTime)) {
                                this.chooseData.push(item);
                            }
                        })
                    } else {
                        data.forEach((item) => {
                            this.chooseData.push(item);
                        })
                    }
                }
                
            },
            changTabFlag(val, obj) {
                this.showTab = val;
                if (obj && obj.date) {
                    let data = JSON.parse(JSON.stringify(this.chooseData));
                    let len = data.length;
                    data.sort((a, b) => a.value - b.value);
                    // console.log(data);
                    let index = data.findIndex(item => {
                        return item.date === obj.date
                    })
                    let max = data[len-1].value;
                    let rate = '0.00', index1 = 0;
                    if (index === 0) {
                        rate = '0.00';
                    } else if (data[index].value === max) {
                        rate = '100.00';
                    } else {
                        for(let i = index; i > 0; i--) {
                            let a = data[i];
                            let b = data[i-1];
                            if (a.value === b.value) {
                                continue;
                            } else {
                                index1 = i - 1;
                                break;
                            }
                        }
                        rate = index1 === 0 ? '0.00' : (((index1 + 1) / len) * 100).toFixed(2);
                    }
                    this.hoverObj.pe = obj.value;
                    this.hoverObj.pePercent = rate;
                    this.hoverObj.tpe = data[Math.floor(len * 0.3)].value;
                    this.hoverObj.spe = data[Math.floor(len * 0.7)].value;
                }
            }
        },
        mounted() {
            if (this.historyList.applyArea === 'PE') {
                this.currentTrend = 'peguzhi';
            } else if (this.historyList.applyArea === 'PB') {
                this.currentTrend = 'pbguzhi';
            }
            this.changeTab('', -1 , false);
        }
    }
</script>

<style lang="less">
.m-chart {
    padding: 0 32px 40px;
    .m-chart-tab {
        height: 170px;
        .m-chart-tab-trend {
            li {
                position: relative;
                display: inline-block;
                span {
                    position: relative;
                    font-family: PingFangSC-Medium;
                    font-size: 32px;
                    color: #999999;
                    font-weight: bold;
                    line-height: 134px;
                    &.m-tab-choose {
                        font-size: 36px;
                        color: #323232;
                    }
                }
                img {
                    width: 40px;
                    height: 12px;
                    position: absolute;
                    bottom: 24px;
                    left: 50%;
                    transform: translateX(-50%);
                }
                em {
                    box-sizing: border-box;
                    position: absolute;
                    top: -30px;
                    right: -54px;
                    // width: 56px;
                    height: 32px;
                    line-height: 30px;
                    padding: 0 4px;
                    background: #F6F6F6;
                    border: 1px solid rgba(0, 0, 0, 0.04);
                    border-radius: 8px 8px 8px 1px;
                    font-family: PingFangSC-Regular;
                    font-size: 24px;
                    color: #666666;
                    text-align: center;
                    font-weight: 400;
                }
                &:first-child {
                    margin-right: 48px;
                }
            }
        }
        .m-chart-tab-legend {
            li {
                margin-right: 48px;
                span {
                    display: inline-block;
                    vertical-align: middle;
                    &:first-child {
                        width: 16px;
                        height: 6px;
                        border-radius: 3px;
                        margin-right: 8px;
                    }
                    &:last-child {
                        line-height: 32px;
                        font-weight: 400;
                    }
                }
            }
        }
    }
    .m-chart-group {
        box-sizing: border-box;
        height: 170px;
        padding-top: 50px;
        display: flex;
        justify-content: space-between;
        li {
            flex: 1;
            padding-right: 16px;
            span {
                display: block;
                &:first-child {
                    font-family: PingFangSC-Regular;
                    font-size: 24px;
                    color: #666666;
                    line-height: 32px;
                    font-weight: 400;
                    margin-bottom: 8px;
                }
                &:last-child {
                    font-family: THSMoneyfont-Medium;
                    font-size: 56px;
                    line-height: 56px;
                    color: #666666;
                }
            }
            &:first-child {
                span {
                    em {
                        display: inline-block;
                        width: 16px;
                        height: 6px;
                        background: #0080FF;
                        border-radius: 3px;
                        margin-right: 8px;
                        vertical-align: middle;
                    }
                    &:last-child {
                        color: #0080FF;
                    }
                }
            }
            &:last-child {
                padding-right: 0;
            }
        }
    }
    .m-chart-year {
        display: flex;
        justify-content: space-between;
        li {
            width: 160px;
            height: 64px;
            line-height: 64px;
            background: #F6F6F6;
            border-radius: 16px;
            text-align: center;
            span {
                font-weight: 400;
            }
            &.m-year-choose {
                background: #ffeae6;
                span {
                    color: #ff330a;
                }
            }
        }
    }
    .m-chart-line-wrapper {
        width: 100%;
        height: 350px;
    }
    .m-chart-line-wrapper1 {
        width: 100%;
        height: 310px;
        background: #FAFAFA;
        margin: 32px 0 12px 0;
        border-radius: 16px;
        .m-no-data {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-family: PingFangSC-Regular;
            color: #000000;
            font-weight: 400;
        }
    }

}
</style>